export const SET_CONFIRM_POPUP = "SET_CONFIRM_POPUP";
export const SET_INFO_POPUP = "SET_INFO_POPUP";
